<template>
    <div class="d-flex flex-column">

        <!-- Tabla con datos -->
        <div style="height:350px; overflow-y:scroll;">

            <table v-if="dataAux.length" id="tabla_consolidado_anual" class="table table-striped  w-100">

                <thead>
                    <th v-for="(item , index) in headers" :key="index" v-text="item"></th>
                </thead>

                <tbody>
                    <tr v-for="(fila, fila_index) in dataAux" :key="fila_index">

                        <template v-for="(data, index_data) in fila.data">

                            <td :key="index_data" class="text-center" v-if="index_data == 0">
                                <ui-checkbox v-model="fila.data[index_data]" style="margin-top: 5px;" @change="checkFila($event, fila_index)"></ui-checkbox>
                            </td>

                            <td :key="index_data" v-else class="text-center">{{ data }}</td>
                        </template>

                        <td class="text-center">
                            <i style="cursor:pointer" v-for="(item, index) in fila.acciones" :key="index" :class="item.icon" :title="item.title" @click="eliminar(item.id)"></i>
                        </td>
                        
                    </tr>
                </tbody>
              
               <tfoot>
                    <tr v-if="totales.length">
                        <td class="text-center pl-2"><b>Total carga</b></td>
                        <td colspan="1"></td>
                        <td class="text-center" v-for="(item, index) in totales" :key="index"><b v-text="item"></b></td>
                        <td class="text-center"><b v-text="totalPeriodo"></b></td>
                        <td></td>
                    </tr>

                    <tr v-else>
                        <td class="text-center pl-2"><b>Total carga</b></td>
                        <td colspan="1"></td>
                        <td class="text-center" v-for="(_, index) in cantidadColumnasVacias" :key="index"><b v-text="0"></b></td>
                        <td></td>
                    </tr>
                </tfoot>
            </table>

            <div class="h-100" v-else>
                <div class="d-flex justify-content-center align-items-center h-100">
                    <p>Sin puertos asignados a la planificación</p>
                </div>
            </div>

        </div>
       
    </div>
</template>

<script>

    import { mapActions, mapState } from 'vuex';
    import { eliminarServiciosPlanificacionAnualCharter } from '../../../../constants/charter';

    export default {

        props : ["data","headers","totales","totalPeriodo","semanas","id_tab"],

        data() {
            return {
                dataAux     : [],
                acciones    : [],
                showTable   : false,
                check_seleccionados : [],
                cantidadColumnasVacias : 0
            }
        },

        computed : {

            ...mapState("charter", ["nuevosPlanificacionAnualMultiple","dataAnioSeleccionado","checkPlanificacionAnual"]),

        },

        methods : {

            ...mapActions('charter',['actionSetCheckPlanificacionAnual','actionSetPuertosSeleccionadosPlanAnual','actionSetDataPlanificacionAnualTabla']),

            async generarBotonesAcciones(dataAux) {

                this.acciones = [];
                this.showTable = false;

                setTimeout(() => this.showTable = true, 100);

                await Object.keys(dataAux).map((_, index) => {

                    let {id, data} = dataAux[index];
                    let dataTemp = [false, ...data];

                    this.dataAux.push({
                        "id_puerto" : id,
                        "data" : dataTemp,
                        "acciones" : [
                            {
                                icon: "fa fa-times text-danger",
                                title: "Eliminar puerto",
                                id: index,
                            }
                        ]
                    });

                });

            },

            async eliminar(index){

                let puerto = '';

                puerto = await this.dataAux[index].data[1];

                this.$vToastify.prompt({
                    body: `"¿Desea eliminar el puerto ${puerto}?"`,
                    answers: { Sí: true, No: false },
                }).then(
                    (respuesta) => respuesta && this.eliminarFila(index)
                );

            },

            async eliminarFila(index){

                this.$vToastify.loader('Eliminando puertos');

                console.log('eliminarFila',this.dataAnioSeleccionado[index].data_complementaria);

                let plan_id = this.dataAnioSeleccionado[index].data_complementaria.annual_plan_id;
                let route_id = this.dataAnioSeleccionado[index].data_complementaria.route_id;
                let isNew   = this.dataAnioSeleccionado[index].new;

                const data = { plan_id, route_id};

                console.log('Borrar este LOG',{ "plans" : [data] });

                if (!isNew) {

                    console.log('Dato desde BD');

                    const {code, message} = await eliminarServiciosPlanificacionAnualCharter({ "plans" : [data] });

                    if (code == 200) {
                        this.$vToastify.stopLoader();
                        this.$vToastify.success( message, "Proceso finalizado");
                        this.actionSetDataPlanificacionAnualTabla();
                    } else {
                        this.$vToastify.stopLoader();
                        this.$vToastify.error( message, "Proceso finalizado");
                    }

                    this.$vToastify.stopLoader();

                } else {

                    // this.actionSetPuertoParaEliminarPlanificacionAnual(index);
                    this.$delete(this.dataAux, index);

                    setTimeout(() => {

                        // this.actionSetDataPlanificacionAnualTabla();
                        this.$vToastify.stopLoader();
                        this.$vToastify.success( "Puertos eliminados en local", "Proceso finalizado");

                    }, 1000);

                }
                
            },
            
            checkFila(event, index){

                let estado         = event;
                let check_filtrado = [];

                if (estado) {

                    let checkListTemp = [{id: index, data : this.dataAnioSeleccionado[index], checked: true} , ...this.checkPlanificacionAnual]

                    this.actionSetCheckPlanificacionAnual(checkListTemp);

                    // Cambia el estado del puerto seleccionado a true
                    this.actionSetPuertosSeleccionadosPlanAnual({id_tab: 1, estado: true});

                } else {

                    // Quita data de la fila seleccionada
                    this.checkPlanificacionAnual.filter((item) => item.id != index && check_filtrado.push(item));

                    this.actionSetCheckPlanificacionAnual(check_filtrado);

                    // Cambia el estado del puerto seleccionado a false
                    this.actionSetPuertosSeleccionadosPlanAnual({id_tab: 1, estado: this.check_seleccionados.length ? true : false});
                    
                }

            },

        },

        mounted(){

            if (this.semanas == 53) {
                
                if(this.id_tab != 4){

                    this.cantidadColumnasVacias = 14;

                }else{

                    this.cantidadColumnasVacias = 15;

                }
                
            }else{

                this.cantidadColumnasVacias = 14;


            }


        },

        watch : {

            data : function(_new){
                if(_new){
                    this.dataAux = [];
                    this.generarBotonesAcciones(_new);
                    this.check_seleccionados = [];
                } 
            },

            nuevosPlanificacionAnualMultiple : function(_new){
                
                if (_new) {

                    const {regiones} = _new

                    this.dataAux.push({
                        "id_puerto" : 0,
                        "id" : 0,
                        "data" : [false, regiones.name, 0,0,0,0,0,0,0,0,0,0,0,0,0,0],
                        "acciones" : [
                            {
                                icon: "fa fa-times text-danger",
                                title: "Eliminar planificación",
                                id: parseInt(this.dataAux.length),
                            },
                            {
                                icon: "fas fa-circle text-success ml-2",
                                title: "Puerto en lista para guardar",
                            }
                        ]
                    });

                }

            },

            checkPlanificacionAnual : function(_new){

                this.dataAux.map( (_, index_data) => {

                    this.dataAux[index_data].data[0] = false;

                    _new.map((checked) => checked.id == index_data && (this.dataAux[index_data].data[0] = true));

                    let dataTemp = this.dataAux;
                    this.dataAux = [];
                    this.dataAux = dataTemp;

                });

            }

        }
            

    }

</script>

<style scoped>

    #tabla_consolidado_anual > thead > th{
        text-align: center;
    }

    table tfoot {
        position: sticky;
        bottom: 0;
        z-index: 1;
    }

    table tfoot td {
        padding: 15px 0;
        background: #bfbfbf;
    }

    table tr th:first-child {
        position: sticky;
        inset-inline-start: 0; /* "left" */
    }

</style>